import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import Header from "../components/Header.js";
import SideBar from "../components/onboardingSidebar.js";
import OnboardingChat, { OnboardingProjectSetup } from "./OnboardingChat.js";

const drawerWidth = 260;

const OnboardingX = () => {
    const [selectedPage, setSelectedPage] = useState("agent_chat");

    return (
        <>
            <CssBaseline />
            <Box sx={{ display: "flex", textAlign: "center", backgroundColor: "#282c34", color: "white", position: "absolute", top: 0, bottom: 0, left: 0, right: 0, overflow: "hidden" }}>
                <Header />
                <Box
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        position: "fixed",
                        left: 0,
                        top: "80px",
                        height: "calc(100vh - 80px)",
                        overflowY: "auto",
                        zIndex: 1000,
                        backgroundColor: "#282c34",
                    }}
                >
                    <SideBar selectedPage={selectedPage} handleNavigation={setSelectedPage} />
                </Box>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        marginLeft: `${drawerWidth}px`,
                        width: `calc(100% - ${drawerWidth}px)`,
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflowY: "auto",
                        p: 2,
                    }}
                >
                    {selectedPage === "agent_chat" && <OnboardingChat />}
                    {selectedPage === "project_setup" && <OnboardingProjectSetup />}
                </Box>
            </Box>
        </>
    );
};

export default OnboardingX;
